const YOUTUBE_PATTERNS = [
  /youtu\.be\/([^?&#/]+)/,
  /[?&]v=([^?&#/]+)/,
  /youtube\.com\/embed\/([^?&#/]+)/,
  /youtube\.com\/v\/([^?&#/]+)/,
];

export function getYouTubeThumbnail(url: string): string {
  for (const pattern of YOUTUBE_PATTERNS) {
    const match = url.match(pattern);
    if (match?.[1]) {
      return `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg`;
    }
  }
  return "";
}

const YOUTUBE_HOSTS = ["youtube.com", "youtube-nocookie.com", "youtu.be"];
const YOUTUBE_PLAYLIST_PARAMS = ["list", "index", "channel"];

/**
 * react-player's YouTube provider treats any URL containing `list=`/`channel=`
 * as a playlist and fails to extract a video ID (throws "Invalid video id"),
 * even for a single-video URL that just happens to carry playlist params
 * (e.g. copied while browsing inside a playlist on youtube.com). Strip those
 * params so a single-video URL always plays.
 */
export function sanitizeYouTubeUrl(url: string): string {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return url;
  }

  const isYouTube = YOUTUBE_HOSTS.some((host) =>
    parsed.hostname.endsWith(host)
  );
  if (!isYouTube) return url;

  YOUTUBE_PLAYLIST_PARAMS.forEach((param) => parsed.searchParams.delete(param));
  return parsed.toString();
}

const TIMESTAMP_PATTERN = /^(\d+):([0-5]?\d)$/;

/**
 * Parses a `mm:ss` timestamp (e.g. "4:32", "12:05") into total seconds.
 * Returns `null` for a missing or malformed value.
 */
export function parseTimestampToSeconds(
  timestamp: string | null | undefined
): number | null {
  if (!timestamp) return null;

  const match = timestamp.match(TIMESTAMP_PATTERN);
  if (!match) return null;

  const minutes = parseInt(match[1], 10);
  const seconds = parseInt(match[2], 10);

  return minutes * 60 + seconds;
}
